import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.css';
import './Logo.css?v=1.0.1';

const Logo = () => {
  return (
    <div className="logo-section">
      <div className="logo">
        <Link to="/" className="logo-link">
          <img src="/logoo.png" alt="Kishore Alo Logo" style={{ height: "80px", width: "auto" }} />
        </Link>
      </div>
    </div>
  );
};

export default Logo;